module.exports = __webpack_public_path__ + "img/award-bg1.d4925961.png";